import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, useLocation, useHistory } from 'react-router-dom'
import { yupResolver } from '@hookform/resolvers/yup'
import ErrorMessage from 'components/layout/ErrorMessage'
import { showLoginOtpHandle } from 'redux-thunk/redux/slices/user.slice'
import {
  // forgetPassword,
  userLogin
} from 'redux-thunk/thunk/auth.thunk'
import { setShowLoginPopup, setShowSignupPopup } from 'redux-thunk/redux/slices/gameSetting.slice'
import Loader from 'components/ui-kit/Loader/index'
import { LOADER_HANDLER_TYPES, ROUTE_PATHS } from 'constants/index.js'
import SocialLinks from '../SocialLinks/index'
import { setShowForgotPasswordPopup } from 'redux-thunk/redux/slices/settings.slice'
import { EyeCloseIcon, EyeIcon } from 'components/ui-kit/Icons/svg/index'

const Login = () => {
  const { t } = useTranslation()
  const { [LOADER_HANDLER_TYPES.submit]: loading } = useSelector(state => state.loader)

  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()

  const [showPassword, setShowPassword] = useState(false)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [token, setToken] = useState('')

  const schema = yup.object().shape({
    userName: yup.string().required(`${t('signinErrorsUserNameRequired')}`),
    password: yup
      .string()
      .required(`${t('signinErrorsPasswordRequired')}`)
      .min(8, `${t('signinErrorsPasswordMinLength')}`)
      .max(16, `${t('signinErrorsPasswordMaxLength')}`),
    userToken: yup.string()
  })

  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onSubmit'
  })

  const onLoginSuccess = () => {
    if (location.pathname.match('/reset-password')) {
      history.replace(ROUTE_PATHS.HOME)
    } else if (location.pathname?.match('/verify')) {
      history.replace(ROUTE_PATHS.HOME)
    } else {
      history.replace(location.pathname)
    }
    dispatch(setShowLoginPopup(false))
    dispatch(setShowSignupPopup(false))
  }

  const OnLoginError = (error) => {
    if (error[0].description === 'otp required') {
      dispatch(setShowLoginPopup(false))
      dispatch(showLoginOtpHandle(true))
      dispatch(setShowSignupPopup(false))
    }
  }

  const handleLoginSubmit = async (loginDetails) => {
    const payload = {
      userNameOrEmail: loginDetails.userName,
      password: loginDetails.password,
      onLoginSuccess,
      OnLoginError
    }
    if (loginDetails.userToken?.trim()?.length > 0) {
      payload.userToken = loginDetails.userToken
    }
    dispatch(
      userLogin(payload)
    )
  }

  const handleTokenChange = (event) => {
    setToken(event.target.value)
  }

  // const handleForgetPassword = async () => {
  //   if (username?.length > 0) {
  //     dispatch(forgetPassword({ userNameOrEmail: username }))
  //   } else {
  //     openErrorToaster({ message: t('signinResetPasswordUsernameErr') })(
  //   }
  // }

  const toggleDropdown = () => {
    setIsDropdownOpen(prevState => !prevState)
  }
  return (
    <div role='tabpanel'>
      <div className='pb-5 pb-sm-0'>
        <form onSubmit={handleSubmit(handleLoginSubmit)}>
          <div className='mb-3 form-group '>
            <label htmlFor='userEmail' className='form-label text-uppercase'>{t('signinUsername')}</label> <span className='color-red '>*</span>
            <input
              type='text'
              placeholder={t('emailPlaceholder')}
              className={`box-border w-full h-10 px-3 py-1 text-base text-[var(--white)] bg-[var(--darkGray)] border-[1px] border-solid border-transparent rounded-lg shadow-[inset_0_1px_0_rgb(var(--pm-gold)/0.06)] outline-none placeholder:!text-[var(--gray-20)] animate-pm-fade-in-up motion-reduce:animate-none [transition:box-shadow_var(--pm-duration-fast,0.16s)_var(--pm-ease,ease),transform_var(--pm-duration,0.24s)_var(--pm-ease-spring,ease)] [background:linear-gradient(145deg,#472e00,#090b0b_25%)_padding-box,linear-gradient(135deg,#8a6500,#ffd700,#b8860b,#b8860b,#8a6500)_border-box] hover:-translate-y-0.5 hover:[background:linear-gradient(145deg,#472e00,#090b0b_35%)_padding-box,linear-gradient(135deg,#8a6500,#ffd700,#b8860b,#b8860b,#8a6500)_border-box] hover:shadow-[inset_0_1px_0_rgb(var(--pm-gold)/0.1),0_6px_18px_rgb(var(--color-shadow)/0.18)] focus:text-[var(--white)] focus:outline-none focus:shadow-none focus-within:shadow-none disabled:bg-[var(--gray-90)] disabled:text-[var(--white)] disabled:cursor-not-allowed read-only:bg-[var(--gray-90)] read-only:text-[var(--white)] ${errors?.userName ? 'error-input' : ''}`}
              id='userName'
              name='userName'
              {...register('userName')}
              autoComplete='off'
              maxLength={50}
            />
            {errors && errors.userName && (
              <div className='error-container'>
                <ErrorMessage
                  className='color-red text-danger error-msg login-input  ms-2 d-flex mb-0'
                  message={errors.userName.message}
                />
              </div>
            )}
          </div>
          <div className='mb-3 form-group '>
            <label htmlFor='userEmail' className='form-label text-uppercase'>{t('profilePassword')}</label> <span className='color-red '>*</span>
            <div className='relative'>
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder='********'
                className={`box-border w-full h-10 px-3 py-1 text-base text-[var(--white)] bg-[var(--darkGray)] border-[1px] border-solid border-transparent rounded-lg shadow-[inset_0_1px_0_rgb(var(--pm-gold)/0.06)] outline-none placeholder:!text-[var(--gray-20)] animate-pm-fade-in-up motion-reduce:animate-none [transition:box-shadow_var(--pm-duration-fast,0.16s)_var(--pm-ease,ease),transform_var(--pm-duration,0.24s)_var(--pm-ease-spring,ease)] [background:linear-gradient(145deg,#472e00,#090b0b_25%)_padding-box,linear-gradient(135deg,#8a6500,#ffd700,#b8860b,#b8860b,#8a6500)_border-box] hover:-translate-y-0.5 hover:[background:linear-gradient(145deg,#472e00,#090b0b_35%)_padding-box,linear-gradient(135deg,#8a6500,#ffd700,#b8860b,#b8860b,#8a6500)_border-box] hover:shadow-[inset_0_1px_0_rgb(var(--pm-gold)/0.1),0_6px_18px_rgb(var(--color-shadow)/0.18)] focus:text-[var(--white)] focus:outline-none focus:shadow-none focus-within:shadow-none disabled:bg-[var(--gray-90)] disabled:text-[var(--white)] disabled:cursor-not-allowed read-only:bg-[var(--gray-90)] read-only:text-[var(--white)] ${errors?.password ? 'error-input' : ''}`}
                id='password'
                name='password'
                autoComplete='off'
                {...register('password')}
                maxLength={50}
                minLength={8}
                aria-label='Username'
                aria-describedby='button-addon1'
              />
              <a
                onClick={() =>
                  setShowPassword((prevState) => !prevState)}
                className='absolute right-3 top-0 bottom-0 items-center flex text-[var(--gray-20'
              >
                {!showPassword
                  ? (
                    <EyeIcon />
                    )
                  : (
                    <EyeCloseIcon />
                    )}
              </a>
            </div>

            <div className='error-container mt-1 d-flex justify-content-between'>
              <div>
                {errors && errors.password && (
                  <ErrorMessage
                    className='color-red text-danger error-msg login-input  ms-2 d-flex mb-0'
                    message={errors.password.message}
                  />
                )}
              </div>
              <a
                href='#'
                className='forgot-password'
                onClick={(e) => {
                  e.preventDefault()
                  dispatch(setShowForgotPasswordPopup(true))
                }}
              >
                {t('signinForgetPassword')}
              </a>
            </div>
          </div>
          {/* <div className='mb-3 form-group  twofa-wrap'>
            <div className='d-flex align-items-center' onClick={!isDropdownOpen ? toggleDropdown : () => {}}>
              <label htmlFor='2FACode' className='form-label text-uppercase' style={{ marginRight: '10px' }}>{t('twoFACode')}</label>
              {!isDropdownOpen && (
                <div className='dropdown-icon mb-2'>
                  <svg viewBox='0 0 24 24' fill='currentColor' className='h-3 w-3' aria-hidden='true' style={{ cursor: 'pointer' }}><path d='M12 16l6-6H6z'/></svg>
                </div>
              )}
            </div>
            {isDropdownOpen && (
              <>
                <input
                  type='text'
                  placeholder={t('code')}
                  className={`box-border w-full h-10 px-3 py-1 text-base text-[var(--white)] bg-[var(--darkGray)] border border-solid border-[var(--darkGray)] rounded-[0.625rem] shadow-none outline-none placeholder:!text-[var(--gray-20)] focus:text-[var(--white)] focus:border-[var(--blue-300)] focus:bg-[var(--darkGray)] focus:outline-none focus:shadow-none focus-within:shadow-none disabled:bg-[var(--gray-90)] disabled:text-[var(--white)] disabled:cursor-not-allowed read-only:bg-[var(--gray-90)] read-only:text-[var(--white)] ${errors?.userToken ? 'error-input' : ''}`}
                  id='userToken'
                  name='userToken'
                  {...register('userToken')}
                  value={token}
                  onChange={handleTokenChange}
                />
                <p className='pt-2 mb-3'>Required if you enabled two-factor authentication</p>
              </>
            )}
            {errors && errors.userToken && (
              <ErrorMessage
                className='color-red text-danger error-msg login-input  ms-2 d-flex mb-0'
                message={errors.userToken.message}
              />
            )}
          </div> */}
          <div className='auth-btn-wrap'>
            <button
              type='submit'
              className='btn btn-secondary w-full'
              disabled={loading}
            >
              {
                loading
                  ? <Loader variant={LOADER_HANDLER_TYPES.submit} />
                  : <span>{t('login')}</span>
              }
            </button>
          </div>
          <div className='auth-socail-wrap'>
            <div className='auth-social-heading'>
              <h6><span>{t('orContinueWith')}</span></h6>
            </div>
          </div>
          <SocialLinks isLoginSignup />
          <div className='auth-mob-instructions d-block d-lg-none pb-5 pb-md-0'>
            <p>
              {t('usersConsent')}
              <NavLink to='#'>{t('termsOfService')}</NavLink>
            </p>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Login
